import { Prohibit, X } from "@phosphor-icons/react";
import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import { Tag } from "common/components/ui/Tag";

export default function SelectionTags<
  OptionType extends Record<string, string> & {
    id: string;
  },
>({
  selection,
  labelKey,
  onRemoveFilter,
  onFlipFilter = null,
}: {
  selection: OptionType[];
  labelKey: keyof OptionType;
  onRemoveFilter: (option: OptionType) => void;
  onFlipFilter?: (option: OptionType) => void;
}) {
  const isExcludeIncludeSelection = !!onFlipFilter;
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5 px-2">
      {selection.map((option) => {
        const { id } = option;
        return (
          <Tag
            size="lg"
            key={id}
            variant={
              option.selectionType === "INCLUDED" || !isExcludeIncludeSelection
                ? "primary-black"
                : "danger"
            }
            className="max-w-full"
            rightIcon={
              <div className="flex items-center gap-x-1">
                <RenderIf condition={isExcludeIncludeSelection}>
                  <button
                    aria-label="flip filter"
                    type="button"
                    onClick={() => {
                      onFlipFilter(option);
                    }}
                  >
                    <Prohibit size={16} className="!m-0" />
                  </button>
                  <div
                    className={clsx(
                      "h-2.5 w-px",
                      option.selectionType === "INCLUDED"
                        ? "bg-white"
                        : "bg-red-500",
                    )}
                  />
                </RenderIf>
                <button
                  aria-label="remove filter"
                  type="button"
                  onClick={() => {
                    onRemoveFilter(option);
                  }}
                >
                  <X size={16} />
                </button>
              </div>
            }
          >
            <span className="truncate">{option[labelKey]}</span>
          </Tag>
        );
      })}
    </div>
  );
}
